
import { takeLatest, put } from 'redux-saga/effects';

import { triggerError } from '../../../stores/global-errors-display/global-errors-display-actions';
import { apiSaga } from '../../../sagas';
import { settings as settingsApi } from '../../../api';
import { getUsersByFilter } from '../../../stores/settings/userManagement/actions';
import * as cnt from './constants';


function* getSettings({ payload: { pathname } }) {
  if (pathname.split('/')[1] === 'settings') {
    yield apiSaga(cnt.GET_SETTINGS, settingsApi.getSettings, []);
  }
}

function* saveSettings({ payload }) {
  yield apiSaga(cnt.SAVE_SETTINGS, settingsApi.saveSettings, [payload]);
}

function* cantAddUser({ payload }) {
  const errorMessage = 'This user cannot be added.';
  if (payload.message) {
    yield put(triggerError({ errorMessage: `${errorMessage} ${payload.message}.` }));
  } else {
    yield put(triggerError({ errorMessage }));
  }
}
function* couldAddUser() {
  yield put({ type: 'UPDATE_UM_PROP', payload: { addingNewUserDialog: false } });
  yield put(getUsersByFilter('user'));
  yield put(getUsersByFilter('team'));
}

export default [
  takeLatest('@@router/LOCATION_CHANGE', getSettings),
  takeLatest('ADD_USER_FAILED', cantAddUser),
  takeLatest('ADDED_USER', couldAddUser),
  takeLatest(cnt.SAVE_SETTINGS, saveSettings),
];



// WEBPACK FOOTER //
// ./src/app/components/settings/__store__/sagas.js